<template>
  <v-container fluid class="bot-send-page">
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center justify-space-between flex-wrap ga-3 mb-4">
          <h1 class="text-h4 mb-0">
            <v-icon class="mr-2">mdi-message-processing</v-icon>
            Хабарлама жіберу
          </h1>
          <div class="d-flex align-center ga-2 flex-wrap">
            <v-chip
              :color="botStatus.isRunning ? 'success' : 'error'"
              size="small"
              variant="flat"
              :prepend-icon="botStatus.isRunning ? 'mdi-robot' : 'mdi-robot-off'"
            >
              {{ botStatus.isRunning ? 'Бот жұмыс істеп тұр' : 'Бот уақытша өшірілген' }}
            </v-chip>
            <v-btn
              v-if="botStatus.isRunning"
              color="error"
              variant="tonal"
              :loading="togglingBot"
              @click="stopBotService"
            >
              <v-icon class="mr-2">mdi-pause-circle</v-icon>
              Сервисті өшіру
            </v-btn>
            <v-btn
              v-else
              color="success"
              variant="tonal"
              :loading="togglingBot"
              @click="startBotService"
            >
              <v-icon class="mr-2">mdi-play-circle</v-icon>
              Сервисті қосу
            </v-btn>
            <v-btn color="primary" variant="tonal" :loading="loading" @click="loadAll">
              <v-icon class="mr-2">mdi-refresh</v-icon>
              Жаңарту
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-tabs v-model="activeTab" color="primary">
            <v-tab value="telegram">
              <v-icon class="mr-2">mdi-telegram</v-icon>
              Telegram
            </v-tab>
            <v-tab value="whatsapp">
              <v-icon class="mr-2">mdi-whatsapp</v-icon>
              WhatsApp
            </v-tab>
            <v-tab value="templates">
              <v-icon class="mr-2">mdi-text-box-edit</v-icon>
              Хат мәтіндері
            </v-tab>
            <v-tab value="history">
              <v-icon class="mr-2">mdi-history</v-icon>
              Тарих
            </v-tab>
          </v-tabs>

          <v-window v-model="activeTab">
            <v-window-item value="telegram">
              <v-card-text>
                <v-row>
                  <v-col cols="12" lg="5">
                    <v-card variant="outlined">
                      <v-card-title>
                        <v-icon class="mr-2">mdi-cog</v-icon>
                        Telegram баптаулары
                      </v-card-title>
                      <v-card-text>
                        <v-form @submit.prevent="saveTelegramSettings">
                          <v-text-field
                            v-model="telegramForm.botToken"
                            label="Bot Token"
                            :placeholder="telegramSettings.botTokenSet ? 'Орнатылған, өзгертсеңіз жаңасын жазыңыз' : 'Bot token енгізіңіз'"
                            :append-inner-icon="showToken ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="showToken ? 'text' : 'password'"
                            @click:append-inner="showToken = !showToken"
                          />

                          <v-text-field
                            v-model="telegramForm.adminChatId"
                            label="Негізгі Admin Chat ID"
                            placeholder="123456789"
                          />

                          <v-switch
                            v-model="telegramForm.isEnabled"
                            color="success"
                            label="Telegram хабарламасын қосу"
                          />
                          <v-switch
                            v-model="telegramForm.notifyNewUser"
                            color="primary"
                            label="Жаңа қолданушы / растау хабарлары"
                            :disabled="!telegramForm.isEnabled"
                          />
                          <v-switch
                            v-model="telegramForm.notifyPayment"
                            color="primary"
                            label="Төлем хабарлары"
                            :disabled="!telegramForm.isEnabled"
                          />
                          <v-switch
                            v-model="telegramForm.notifyExpiry"
                            color="primary"
                            label="Мерзім хабарлары"
                            :disabled="!telegramForm.isEnabled"
                          />

                          <div class="d-flex ga-2 flex-wrap mt-3">
                            <v-btn color="primary" type="submit" :loading="savingTelegram">
                              <v-icon class="mr-2">mdi-content-save</v-icon>
                              Сақтау
                            </v-btn>
                            <v-btn color="info" variant="tonal" :loading="testingTelegram" @click="sendTelegramTest">
                              <v-icon class="mr-2">mdi-send</v-icon>
                              Тест
                            </v-btn>
                          </div>
                        </v-form>
                      </v-card-text>
                    </v-card>

                    <v-card variant="outlined" class="mt-4">
                      <v-card-title>
                        <v-icon class="mr-2">mdi-key</v-icon>
                        Верификация коды
                      </v-card-title>
                      <v-card-text>
                        <v-text-field
                          v-model="telegramSettings.verificationCode"
                          label="Код"
                          readonly
                          :append-inner-icon="showCode ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showCode ? 'text' : 'password'"
                          @click:append-inner="showCode = !showCode"
                        />
                        <v-btn color="warning" variant="tonal" :loading="regenerating" @click="regenerateTelegramCode">
                          <v-icon class="mr-2">mdi-refresh</v-icon>
                          Жаңа код
                        </v-btn>
                      </v-card-text>
                    </v-card>

                    <v-card variant="outlined" class="mt-4">
                      <v-card-title>
                        <v-icon class="mr-2">mdi-account-group</v-icon>
                        Қосылған админдер
                      </v-card-title>
                      <v-card-text>
                        <v-alert v-if="telegramAdmins.length === 0" type="info" density="compact">
                          Әзірге Telegram админдері қосылмаған.
                        </v-alert>
                        <v-list v-else density="compact">
                          <v-list-item v-for="admin in telegramAdmins" :key="admin.chatId">
                            <template #prepend>
                              <v-icon :color="admin.isPrimary ? 'primary' : 'grey'">
                                {{ admin.isPrimary ? 'mdi-star' : 'mdi-account' }}
                              </v-icon>
                            </template>
                            <v-list-item-title>{{ admin.chatId }}</v-list-item-title>
                            <v-list-item-subtitle>{{ formatDate(admin.addedAt) }}</v-list-item-subtitle>
                            <template #append>
                              <v-btn icon variant="text" color="error" size="small" @click="removeTelegramAdmin(admin.chatId)">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                          </v-list-item>
                        </v-list>
                        <v-divider class="my-3" />
                        <div class="d-flex ga-2 align-center">
                          <v-text-field
                            v-model="newAdminChatId"
                            label="Жаңа админ Chat ID"
                            placeholder="Chat ID енгізіңіз"
                            density="compact"
                            hide-details
                            variant="outlined"
                            @keyup.enter="addTelegramAdmin"
                          />
                          <v-btn
                            color="primary"
                            variant="tonal"
                            :loading="addingAdmin"
                            @click="addTelegramAdmin"
                          >
                            <v-icon>mdi-plus</v-icon>
                            Қосу
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="7">
                    <message-template-editor
                      channel="telegram"
                      :templates="templates"
                      :saving="savingTemplates"
                      @save="saveTemplates"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-window-item>

            <v-window-item value="whatsapp">
              <v-card-text>
                <v-row>
                  <v-col cols="12" lg="5">
                    <v-card variant="outlined">
                      <v-card-title>
                        <v-icon class="mr-2">mdi-whatsapp</v-icon>
                        WhatsApp баптаулары
                      </v-card-title>
                      <v-card-text>
                        <v-form @submit.prevent="saveWhatsAppSettings">
                          <v-text-field
                            v-model="whatsappForm.serviceUrl"
                            label="WhatsApp service URL"
                            placeholder="http://127.0.0.1:3031"
                          />
                          <v-textarea
                            v-model="whatsappForm.adminChatNamesText"
                            label="Админ чат атаулары"
                            hint="Әр WhatsApp чат атауын жаңа жолға жазыңыз"
                            persistent-hint
                            rows="4"
                          />
                          <v-text-field
                            v-model="whatsappForm.testPhone"
                            label="Тест нөмірі"
                            hint="Қаласаңыз, тестті чат атауымен емес, нақты WhatsApp нөміріне жіберуге болады"
                            placeholder="+77001234567"
                            persistent-hint
                          />

                          <v-switch
                            v-model="whatsappForm.isEnabled"
                            color="success"
                            label="WhatsApp хабарламасын қосу"
                          />
                          <v-switch
                            v-model="whatsappForm.notifyNewUser"
                            color="primary"
                            label="Жаңа қолданушы / растау хабарлары"
                            :disabled="!whatsappForm.isEnabled"
                          />
                          <v-switch
                            v-model="whatsappForm.notifyPayment"
                            color="primary"
                            label="Төлем хабарлары"
                            :disabled="!whatsappForm.isEnabled"
                          />
                          <v-switch
                            v-model="whatsappForm.notifyExpiry"
                            color="primary"
                            label="Мерзім хабарлары"
                            :disabled="!whatsappForm.isEnabled"
                          />

                          <div class="d-flex ga-2 flex-wrap mt-3">
                            <v-btn color="primary" type="submit" :loading="savingWhatsApp">
                              <v-icon class="mr-2">mdi-content-save</v-icon>
                              Сақтау
                            </v-btn>
                            <v-btn color="success" variant="tonal" :loading="testingWhatsApp" @click="sendWhatsAppTest">
                              <v-icon class="mr-2">mdi-send</v-icon>
                              Тест
                            </v-btn>
                            <v-btn color="warning" variant="tonal" :loading="openingWhatsApp" @click="openWhatsAppBrowser">
                              <v-icon class="mr-2">mdi-web</v-icon>
                              Alshyn / QR
                            </v-btn>
                            <v-btn color="info" variant="text" :loading="checkingWhatsApp" @click="loadWhatsAppStatus">
                              <v-icon class="mr-2">mdi-pulse</v-icon>
                              Статус
                            </v-btn>
                            <v-btn color="info" variant="text" :loading="loadingWhatsAppScreenshot" @click="loadWhatsAppScreenshot">
                              <v-icon class="mr-2">mdi-qrcode-scan</v-icon>
                              QR жаңарту
                            </v-btn>
                          </div>
                        </v-form>

                        <v-alert v-if="whatsappStatus" class="mt-4" :type="whatsappStatus.success ? 'success' : 'warning'" density="compact">
                          {{ whatsappStatusText }}
                        </v-alert>

                        <v-alert type="info" variant="tonal" density="compact" class="mt-4">
                          WhatsApp Web байланысы үшін алдымен Alshyn браузерін ашып, шыққан QR кодты телефоныңыздағы WhatsApp арқылы сканерлеңіз.
                        </v-alert>

                        <v-card v-if="whatsappScreenshotSrc" variant="outlined" class="mt-4 qr-preview-card">
                          <v-card-title class="text-subtitle-1">
                            <v-icon class="mr-2">mdi-qrcode</v-icon>
                            WhatsApp Web QR / браузер көрінісі
                          </v-card-title>
                          <v-card-text>
                            <v-img
                              :src="whatsappScreenshotSrc"
                              max-height="420"
                              contain
                              class="rounded border"
                            />
                          </v-card-text>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="7">
                    <message-template-editor
                      channel="whatsapp"
                      :templates="templates"
                      :saving="savingTemplates"
                      @save="saveTemplates"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-window-item>

            <v-window-item value="templates">
              <v-card-text>
                <v-alert type="info" variant="tonal" class="mb-4">
                  Бұл жерде барлық ортақ хат мәтіндері сақталады. Әр оқиға үшін Telegram және WhatsApp мәтінін бөлек өзгерте аласыз, ал жіберу кезінде жүйе осы шаблондарды динамикалық толтырады.
                </v-alert>
                <v-row>
                  <v-col cols="12" lg="6">
                    <message-template-editor
                      channel="telegram"
                      :templates="templates"
                      :saving="savingTemplates"
                      @save="saveTemplates"
                    />
                  </v-col>
                  <v-col cols="12" lg="6">
                    <message-template-editor
                      channel="whatsapp"
                      :templates="templates"
                      :saving="savingTemplates"
                      @save="saveTemplates"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-window-item>

            <v-window-item value="history">
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-card variant="outlined">
                      <v-card-text class="text-center">
                        <div class="text-h4 text-primary">{{ stats?.total || 0 }}</div>
                        <div class="text-caption">Барлығы</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card variant="outlined">
                      <v-card-text class="text-center">
                        <div class="text-h4 text-success">{{ stats?.successful || 0 }}</div>
                        <div class="text-caption">Сәтті</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card variant="outlined">
                      <v-card-text class="text-center">
                        <div class="text-h4 text-error">{{ stats?.failed || 0 }}</div>
                        <div class="text-caption">Қате</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <v-card variant="outlined" class="mt-4">
                  <v-card-title>
                    <v-icon class="mr-2">mdi-history</v-icon>
                    Хабарламалар тарихы
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="historyHeaders"
                      :items="notifications"
                      :loading="loadingNotifications"
                      :items-per-page="10"
                    >
                      <template #item.channel="{ item }">
                        <v-chip size="small" :color="item.channel === 'telegram' ? 'info' : 'success'">
                          {{ item.channel }}
                        </v-chip>
                      </template>
                      <template #item.success="{ item }">
                        <v-icon :color="item.success ? 'success' : 'error'">
                          {{ item.success ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                        </v-icon>
                      </template>
                      <template #item.createdAt="{ item }">
                        {{ formatDate(item.createdAt) }}
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-window-item>
          </v-window>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3500">
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { computed, defineComponent, h, onMounted, reactive, ref } from 'vue'
import axios from 'axios'
import {
  VAlert,
  VBtn,
  VCard,
  VCardText,
  VCardTitle,
  VChip,
  VExpansionPanel,
  VExpansionPanels,
  VExpansionPanelText,
  VExpansionPanelTitle,
  VIcon,
  VSpacer,
  VSwitch,
  VTextarea
} from 'vuetify/components'

const API_BASE = '/api/bot-send-message'

const MessageTemplateEditor = defineComponent({
  name: 'MessageTemplateEditor',
  props: {
    channel: { type: String, required: true },
    templates: { type: Array, required: true },
    saving: { type: Boolean, default: false }
  },
  emits: ['save'],
  setup(props, { emit }) {
    const label = computed(() => props.channel === 'telegram' ? 'Telegram мәтіні' : 'WhatsApp мәтіні')
    const field = computed(() => props.channel === 'telegram' ? 'telegramText' : 'whatsappText')

    const insertVariable = (template, variable) => {
      template[field.value] = `${template[field.value] || ''} {{${variable}}}`
    }

    return () => {
      return h(VCard, { variant: 'outlined' }, {
        default: () => [
          h(VCardTitle, null, {
            default: () => [
              h(VIcon, { class: 'mr-2' }, { default: () => 'mdi-text-box-edit' }),
              'Хабарлама мәтіндері',
              h(VSpacer),
              h(VBtn, {
                color: 'primary',
                loading: props.saving,
                onClick: () => emit('save')
              }, {
                default: () => [
                  h(VIcon, { class: 'mr-2' }, { default: () => 'mdi-content-save' }),
                  'Мәтіндерді сақтау'
                ]
              })
            ]
          }),
          h(VCardText, null, {
            default: () => h(VExpansionPanels, { variant: 'accordion' }, {
              default: () => props.templates.map((template) => h(VExpansionPanel, { key: template.key }, {
                default: () => [
                  h(VExpansionPanelTitle, null, {
                    default: () => h('div', null, [
                      h('div', { class: 'font-weight-medium' }, template.title),
                      h('div', { class: 'text-caption text-medium-emphasis' }, template.key)
                    ])
                  }),
                  h(VExpansionPanelText, null, {
                    default: () => [
                      template.description
                        ? h(VAlert, {
                          type: 'info',
                          variant: 'tonal',
                          density: 'compact',
                          class: 'mb-3'
                        }, { default: () => template.description })
                        : null,
                      h('div', { class: 'd-flex ga-2 flex-wrap mb-3' }, (template.variables || []).map((variable) => h(VChip, {
                        key: variable,
                        size: 'small',
                        variant: 'tonal',
                        onClick: () => insertVariable(template, variable)
                      }, { default: () => variable }))),
                      h(VTextarea, {
                        modelValue: template[field.value],
                        'onUpdate:modelValue': (value) => {
                          template[field.value] = value
                        },
                        label: label.value,
                        rows: 9,
                        autoGrow: true,
                        class: 'template-textarea'
                      }),
                      h(VSwitch, {
                        modelValue: template.isEnabled,
                        'onUpdate:modelValue': (value) => {
                          template.isEnabled = value
                        },
                        color: 'success',
                        label: 'Бұл template белсенді'
                      })
                    ]
                  })
                ]
              }))
            })
          })
        ]
      })
    }
  }
})

export default {
  name: 'BotSendMessage',
  components: { MessageTemplateEditor },
  setup() {
    const activeTab = ref('telegram')
    const loading = ref(false)
    const togglingBot = ref(false)
    const botStatus = ref({ isRunning: true })
    const savingTelegram = ref(false)
    const savingWhatsApp = ref(false)
    const savingTemplates = ref(false)
    const testingTelegram = ref(false)
    const testingWhatsApp = ref(false)
    const openingWhatsApp = ref(false)
    const regenerating = ref(false)
    const checkingWhatsApp = ref(false)
    const loadingWhatsAppScreenshot = ref(false)
    const loadingNotifications = ref(false)
    const showToken = ref(false)
    const showCode = ref(false)

    const templates = ref([])
    const telegramAdmins = ref([])
    const stats = ref(null)
    const newAdminChatId = ref('')
    const addingAdmin = ref(false)
    const notifications = ref([])
    const whatsappStatus = ref(null)
    const whatsappScreenshot = ref(null)

    const telegramSettings = ref({
      botTokenSet: false,
      verificationCode: ''
    })

    const telegramForm = reactive({
      botToken: '',
      adminChatId: '',
      isEnabled: false,
      notifyNewUser: true,
      notifyPayment: true,
      notifyExpiry: true
    })

    const whatsappForm = reactive({
      serviceUrl: 'http://127.0.0.1:3031',
      adminChatNamesText: '',
      testPhone: '',
      isEnabled: false,
      notifyNewUser: true,
      notifyPayment: true,
      notifyExpiry: true
    })

    const snackbar = reactive({
      show: false,
      text: '',
      color: 'success'
    })

    const historyHeaders = [
      { title: 'Канал', key: 'channel', width: '110px' },
      { title: 'Статус', key: 'success', width: '90px' },
      { title: 'Тип', key: 'type' },
      { title: 'Алушы', key: 'recipient' },
      { title: 'Қолданушы', key: 'userName' },
      { title: 'Уақыт', key: 'createdAt', width: '160px' }
    ]

    const whatsappStatusText = computed(() => {
      if (!whatsappStatus.value) return ''
      if (!whatsappStatus.value.success) return whatsappStatus.value.error || 'WhatsApp service жауап бермеді'
      const rawStatus = whatsappStatus.value.status || {}
      const state = rawStatus.browserState || rawStatus.status?.browserState || rawStatus.status || rawStatus
      if (rawStatus.reachable === false) return 'WhatsApp service қосулы, бірақ Alshyn браузері әлі ашылмаған'
      if (state?.qrRequired) return 'WhatsApp QR авторизациясын күтуде. QR кодты телефоннан сканерлеңіз'
      if (state?.authenticated) return 'WhatsApp Web авторизацияланған'
      return 'WhatsApp service қосулы'
    })

    const whatsappScreenshotSrc = computed(() => {
      const data = whatsappScreenshot.value?.screenshot?.data || whatsappScreenshot.value?.data
      return data ? `data:image/png;base64,${data}` : ''
    })

    const getAuthHeader = () => {
      const token = sessionStorage.getItem('korkem-auto-token') || localStorage.getItem('korkem-auto-token')
      return { Authorization: `Bearer ${token}` }
    }

    const showMessage = (text, color = 'success') => {
      snackbar.text = text
      snackbar.color = color
      snackbar.show = true
    }

    const requestConfig = () => ({ headers: getAuthHeader() })

    const loadTelegramSettings = async () => {
      const response = await axios.get(`${API_BASE}/telegram/settings`, requestConfig())
      const settings = response.data.settings || {}
      telegramSettings.value = settings
      telegramForm.adminChatId = settings.adminChatId || ''
      telegramForm.isEnabled = Boolean(settings.isEnabled)
      telegramForm.notifyNewUser = settings.notifyNewUser !== false
      telegramForm.notifyPayment = settings.notifyPayment !== false
      telegramForm.notifyExpiry = settings.notifyExpiry !== false
    }

    const loadWhatsAppSettings = async () => {
      const response = await axios.get(`${API_BASE}/whatsapp/settings`, requestConfig())
      const settings = response.data.settings || {}
      whatsappForm.serviceUrl = settings.serviceUrl || 'http://127.0.0.1:3031'
      whatsappForm.adminChatNamesText = (settings.adminChatNames || []).join('\n')
      whatsappForm.isEnabled = Boolean(settings.isEnabled)
      whatsappForm.notifyNewUser = settings.notifyNewUser !== false
      whatsappForm.notifyPayment = settings.notifyPayment !== false
      whatsappForm.notifyExpiry = settings.notifyExpiry !== false
    }

    const loadTemplates = async () => {
      const response = await axios.get(`${API_BASE}/templates`, requestConfig())
      templates.value = response.data.templates || []
    }

    const loadTelegramAdmins = async () => {
      const response = await axios.get(`${API_BASE}/telegram/admins`, requestConfig())
      telegramAdmins.value = response.data.admins || []
    }

    const loadStats = async () => {
      const response = await axios.get(`${API_BASE}/stats`, requestConfig())
      stats.value = response.data.stats || null
    }

    const loadNotifications = async () => {
      loadingNotifications.value = true
      try {
        const response = await axios.get(`${API_BASE}/notifications`, requestConfig())
        notifications.value = response.data.notifications || []
      } finally {
        loadingNotifications.value = false
      }
    }

    const loadAll = async () => {
      loading.value = true
      try {
        await Promise.all([
          loadTelegramSettings(),
          loadWhatsAppSettings(),
          loadTemplates(),
          loadTelegramAdmins(),
          loadStats(),
          loadNotifications(),
          loadBotStatus()
        ])
      } catch (error) {
        showMessage(error.response?.data?.error || 'Деректерді жүктеу қатесі', 'error')
      } finally {
        loading.value = false
      }
    }

    const loadBotStatus = async () => {
      try {
        const { data } = await axios.get(`${API_BASE}/telegram/bot-status`, requestConfig())
        if (data?.success) botStatus.value = data.status || { isRunning: false }
      } catch (error) {
        // Status тек ақпарат — қателікті жасырамыз
      }
    }

    const startBotService = async () => {
      togglingBot.value = true
      try {
        const { data } = await axios.post(`${API_BASE}/telegram/bot/start`, {}, requestConfig())
        if (data?.success) {
          botStatus.value = data.status || { isRunning: true }
          showMessage('Telegram бот сервисі қосылды')
        }
      } catch (error) {
        showMessage(error.response?.data?.error || 'Ботты қосу қатесі', 'error')
      } finally {
        togglingBot.value = false
      }
    }

    const stopBotService = async () => {
      if (!confirm('Telegram бот сервисін уақытша өшіруге сенімдісіз бе? Студенттер ботқа жаза алмайды.')) return
      togglingBot.value = true
      try {
        const { data } = await axios.post(`${API_BASE}/telegram/bot/stop`, {}, requestConfig())
        if (data?.success) {
          botStatus.value = data.status || { isRunning: false }
          showMessage('Telegram бот сервисі уақытша өшірілді')
        }
      } catch (error) {
        showMessage(error.response?.data?.error || 'Ботты өшіру қатесі', 'error')
      } finally {
        togglingBot.value = false
      }
    }

    const saveTelegramSettings = async () => {
      savingTelegram.value = true
      try {
        await axios.put(`${API_BASE}/telegram/settings`, {
          botToken: telegramForm.botToken || undefined,
          adminChatId: telegramForm.adminChatId,
          isEnabled: telegramForm.isEnabled,
          notifyNewUser: telegramForm.notifyNewUser,
          notifyPayment: telegramForm.notifyPayment,
          notifyExpiry: telegramForm.notifyExpiry
        }, requestConfig())
        telegramForm.botToken = ''
        await loadTelegramSettings()
        showMessage('Telegram баптаулары сақталды')
      } catch (error) {
        showMessage(error.response?.data?.error || 'Telegram сақтау қатесі', 'error')
      } finally {
        savingTelegram.value = false
      }
    }

    const saveWhatsAppSettings = async () => {
      savingWhatsApp.value = true
      try {
        const adminChatNames = whatsappForm.adminChatNamesText
          .split('\n')
          .map((name) => name.trim())
          .filter(Boolean)
        await axios.put(`${API_BASE}/whatsapp/settings`, {
          serviceUrl: whatsappForm.serviceUrl,
          adminChatNames,
          isEnabled: whatsappForm.isEnabled,
          notifyNewUser: whatsappForm.notifyNewUser,
          notifyPayment: whatsappForm.notifyPayment,
          notifyExpiry: whatsappForm.notifyExpiry
        }, requestConfig())
        await loadWhatsAppSettings()
        showMessage('WhatsApp баптаулары сақталды')
      } catch (error) {
        showMessage(error.response?.data?.error || 'WhatsApp сақтау қатесі', 'error')
      } finally {
        savingWhatsApp.value = false
      }
    }

    const saveTemplates = async () => {
      savingTemplates.value = true
      try {
        const response = await axios.put(`${API_BASE}/templates`, {
          templates: templates.value
        }, requestConfig())
        templates.value = response.data.templates || []
        showMessage('Хабарлама мәтіндері сақталды')
      } catch (error) {
        showMessage(error.response?.data?.error || 'Мәтіндерді сақтау қатесі', 'error')
      } finally {
        savingTemplates.value = false
      }
    }

    const sendTelegramTest = async () => {
      testingTelegram.value = true
      try {
        await axios.post(`${API_BASE}/telegram/test`, {
          botToken: telegramForm.botToken || undefined,
          chatId: telegramForm.adminChatId || undefined
        }, requestConfig())
        await Promise.all([loadStats(), loadNotifications()])
        showMessage('Telegram тест хабарламасы жіберілді')
      } catch (error) {
        showMessage(error.response?.data?.error || 'Telegram тест жіберу қатесі', 'error')
      } finally {
        testingTelegram.value = false
      }
    }

    const sendWhatsAppTest = async () => {
      testingWhatsApp.value = true
      try {
        const firstChat = whatsappForm.adminChatNamesText.split('\n').map((name) => name.trim()).find(Boolean)
        const testPhone = whatsappForm.testPhone.trim()
        if (!firstChat && !testPhone) {
          showMessage('Тест үшін админ чат атауын немесе тест нөмірін жазыңыз', 'warning')
          return
        }
        await axios.post(`${API_BASE}/whatsapp/test`, {
          chatName: firstChat,
          phone: testPhone || undefined
        }, requestConfig())
        await Promise.all([loadStats(), loadNotifications()])
        showMessage('WhatsApp тест хабарламасы жіберілді')
      } catch (error) {
        const details = error.response?.data?.result?.results?.[0]?.details
        const qrRequired = details?.code === 'QR_REQUIRED' || details?.details?.code === 'QR_REQUIRED'
        showMessage(qrRequired ? 'Алдымен Alshyn браузеріндегі WhatsApp QR кодын сканерлеңіз' : (error.response?.data?.error || 'WhatsApp тест жіберу қатесі'), 'error')
      } finally {
        testingWhatsApp.value = false
      }
    }

    const regenerateTelegramCode = async () => {
      regenerating.value = true
      try {
        const response = await axios.post(`${API_BASE}/telegram/regenerate-code`, {}, requestConfig())
        telegramSettings.value.verificationCode = response.data.verificationCode
        showMessage('Жаңа код дайын')
      } catch (error) {
        showMessage(error.response?.data?.error || 'Код жаңарту қатесі', 'error')
      } finally {
        regenerating.value = false
      }
    }

    const removeTelegramAdmin = async (chatId) => {
      if (!confirm(`Chat ID ${chatId} өшіру керек пе?`)) return
      try {
        await axios.delete(`${API_BASE}/telegram/admins/${chatId}`, requestConfig())
        await loadTelegramAdmins()
        showMessage('Админ өшірілді')
      } catch (error) {
        showMessage(error.response?.data?.error || 'Админ өшіру қатесі', 'error')
      }
    }

    const loadWhatsAppStatus = async () => {
      checkingWhatsApp.value = true
      try {
        const response = await axios.get(`${API_BASE}/whatsapp/status`, requestConfig())
        whatsappStatus.value = response.data.status
      } catch (error) {
        whatsappStatus.value = { success: false, error: error.response?.data?.error || error.message }
      } finally {
        checkingWhatsApp.value = false
      }
    }

    const loadWhatsAppScreenshot = async () => {
      loadingWhatsAppScreenshot.value = true
      try {
        const response = await axios.get(`${API_BASE}/whatsapp/screenshot`, requestConfig())
        whatsappScreenshot.value = response.data.screenshot?.screenshot || response.data.screenshot
      } catch (error) {
        whatsappScreenshot.value = null
        showMessage(error.response?.data?.error || 'QR суретін алу қатесі', 'error')
      } finally {
        loadingWhatsAppScreenshot.value = false
      }
    }

    const openWhatsAppBrowser = async () => {
      openingWhatsApp.value = true
      try {
        const response = await axios.post(`${API_BASE}/whatsapp/open`, {}, requestConfig())
        whatsappStatus.value = response.data.status
        await loadWhatsAppScreenshot()
        showMessage('Alshyn браузері ашылды. QR код шықса, телефонмен сканерлеңіз')
      } catch (error) {
        whatsappStatus.value = { success: false, error: error.response?.data?.error || error.message }
        showMessage(error.response?.data?.error || 'Alshyn браузерін ашу қатесі', 'error')
      } finally {
        openingWhatsApp.value = false
      }
    }

    const addTelegramAdmin = async () => {
      const chatId = newAdminChatId.value.trim()
      if (!chatId) {
        showMessage('Chat ID енгізіңіз', 'warning')
        return
      }
      addingAdmin.value = true
      try {
        await axios.post(`${API_BASE}/telegram/admins`, { chatId }, requestConfig())
        newAdminChatId.value = ''
        await loadTelegramAdmins()
        showMessage('Админ қосылды')
      } catch (error) {
        showMessage(error.response?.data?.error || 'Админ қосу қатесі', 'error')
      } finally {
        addingAdmin.value = false
      }
    }

    const formatDate = (dateStr) => {
      if (!dateStr) return ''
      return new Date(dateStr).toLocaleString('kk-KZ', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    }

    onMounted(loadAll)

    return {
      activeTab,
      addTelegramAdmin,
      addingAdmin,
      botStatus,
      togglingBot,
      startBotService,
      stopBotService,
      checkingWhatsApp,
      formatDate,
      newAdminChatId,
      historyHeaders,
      loadAll,
      loadWhatsAppScreenshot,
      loadWhatsAppStatus,
      loadingWhatsAppScreenshot,
      loading,
      loadingNotifications,
      notifications,
      openWhatsAppBrowser,
      openingWhatsApp,
      regenerateTelegramCode,
      regenerating,
      removeTelegramAdmin,
      saveTelegramSettings,
      saveTemplates,
      saveWhatsAppSettings,
      savingTelegram,
      savingTemplates,
      savingWhatsApp,
      sendTelegramTest,
      sendWhatsAppTest,
      showCode,
      showToken,
      snackbar,
      stats,
      telegramAdmins,
      telegramForm,
      telegramSettings,
      templates,
      testingTelegram,
      testingWhatsApp,
      whatsappForm,
      whatsappScreenshotSrc,
      whatsappStatus,
      whatsappStatusText
    }
  }
}
</script>

<style scoped>
.bot-send-page :deep(.v-expansion-panel-title) {
  min-height: 68px;
}

.template-textarea :deep(textarea) {
  font-family: "JetBrains Mono", "Consolas", monospace;
  line-height: 1.45;
}

.qr-preview-card {
  overflow: hidden;
}
</style>
